// extracted by mini-css-extract-plugin
module.exports = {"miniChart":"miniChart_3ddVV","chartContent":"chartContent_CYV1n","chartLoading":"chartLoading_1HdKs"};